module.exports = __webpack_public_path__ + "static/media/automatedcontent_section1.6d37baa7.png";